import React, {useRef, useEffect, useState} from 'react'
import {Helmet} from 'react-helmet'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {useCurrentCustomer} from '@salesforce/retail-react-app/app/hooks/use-current-customer'
import {generateRandomString} from '../../utils/utils'

const baseUrl = 'https://cloud.news.delonghi.com/delonghi-together-refer'

const ReferralDashboard = () => {
    const {locale} = useMultiSite()
    const {data: customer} = useCurrentCustomer()
    const hasPopulated = useRef(false)
    const [iframeHeight, setIframeHeight] = useState('2000px')

    function populateIframeSrc() {
        if (!customer?.customerId || !customer?.c_gigyaId || !locale?.alias) {
            console.error('customerId, customer.c_gigyaId or locale?.alias not available.')
        } else {
            const randomStart = generateRandomString(4)
            const randomEnd = generateRandomString(4)
            const newSrc = `${baseUrl}?id=${randomStart}${customer?.c_gigyaId}${randomEnd}&or=pa&l=${locale?.alias}`
            const iframe = document.getElementById('dynamicIframe')
            if (iframe) {
                iframe.src = newSrc
            }
        }
    }

    useEffect(() => {
        if (!hasPopulated.current && customer?.customerId && customer?.c_gigyaId && locale?.alias) {
            populateIframeSrc()
            hasPopulated.current = true
        }
    }, [customer?.customerId, customer?.c_gigyaId, locale?.alias])

    useEffect(() => {
        const trustedOrigins = ['https://cloud.news.delonghi.com', window.location.origin]
        const handleMessage = (event) => {
            if (!trustedOrigins.includes(event.origin)) return
            if (
                event.data?.source === 'mc-coupon-frame' &&
                event.data?.action === 'resize' &&
                event.data?.height
            ) {
                setIframeHeight(`${event.data.height}px`)
            }
        }
        window.addEventListener('message', handleMessage)
        return () => window.removeEventListener('message', handleMessage)
    }, [])

    return (
        <>
            <Helmet>
                <script
                    type="text/javascript"
                    src="https://view.ceros.com/scroll-proxy.min.js"
                    data-ceros-origin-domains="sfmc-content.com"
                ></script>
            </Helmet>
            <iframe
                id="dynamicIframe"
                allow="clipboard-write; web-share"
                allowFullScreen
                src={baseUrl}
                style={{
                    margin: 0,
                    padding: 0,
                    border: '0 none',
                    height: iframeHeight,
                    width: '100%',
                }}
                className="ceros-experience"
                title="March 2024 | De&#039;Longhi: Your Coffee Guide Copy"
            ></iframe>
        </>
    )
}

export default ReferralDashboard
